module.exports = __webpack_public_path__ + "img/z.76cbfda9.jpg";